import { Option } from '@bbl-digital/snorre-v2'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'

type Filter = {
  searchString?: string
  selectedTags?: Option[]
  documentType?: string
  fileType?: string
  currentPage?: number
  pageSize?: number
  startDate?: string
  endDate?: string
  isOlderThan5Years?: boolean
}

const initialState: Filter = {
  searchString: '',
  selectedTags: [],
  documentType: '',
  fileType: '',
  currentPage: 1,
  pageSize: 10,
  startDate: '',
  endDate: '',
  isOlderThan5Years: false,
}

const bblArchiveSlice = createSlice({
  name: 'bblArchive',
  initialState,
  reducers: {
    resetBBLArchiveFilters: (state) => {
      state.searchString = initialState.searchString
      state.selectedTags = initialState.selectedTags
      state.documentType = initialState.documentType
      state.fileType = initialState.fileType
      state.currentPage = initialState.currentPage
      state.startDate = initialState.startDate
      state.endDate = initialState.endDate
      state.isOlderThan5Years = initialState.isOlderThan5Years
    },
    setBBLSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    setBBLSelectedTags: (state, action: PayloadAction<Option[]>) => {
      state.selectedTags = action.payload
    },

    setBBLDocumentType: (state, action: PayloadAction<string>) => {
      state.documentType = action.payload
    },
    setBBLFileType: (state, action: PayloadAction<string>) => {
      state.fileType = action.payload
    },
    setBBLIsOlderThan5Years: (state, action: PayloadAction<boolean>) => {
      state.isOlderThan5Years = action.payload
    },
    setBBLCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setBBLPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setBBLStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload
    },
    setBBLEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload
    },
    setBBLFilter: (state, action: PayloadAction<Filter>) => {
      state.searchString = action.payload.searchString
      state.selectedTags = action.payload.selectedTags
      state.documentType = action.payload.documentType
      state.fileType = action.payload.fileType
      state.currentPage = action.payload.currentPage
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
      state.isOlderThan5Years = action.payload.isOlderThan5Years
    },
  },
})

export const {
  resetBBLArchiveFilters,
  setBBLSearchString,
  setBBLSelectedTags,
  setBBLDocumentType,
  setBBLFileType,
  setBBLCurrentPage,
  setBBLPageSize,
  setBBLFilter,
  setBBLStartDate,
  setBBLEndDate,
  setBBLIsOlderThan5Years,
} = bblArchiveSlice.actions

export default bblArchiveSlice

export const getBBLArchiveFilters = (state: RootState) => state.bblArchive
